import { useState, useRef, useEffect, memo, type ReactNode } from "react";
import { Button } from "./button";

interface ExpandableTextProps {
  children: ReactNode;
  lineClampClass?: string;
  className?: string;
}

export const ExpandableText = memo(function ExpandableText({
  children,
  lineClampClass = "line-clamp-6",
  className = "",
}: ExpandableTextProps) {
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (el) {
      const checkOverflow = () => {
        setShowToggle(el.scrollHeight > el.clientHeight);
      };
      checkOverflow();
      window.addEventListener("resize", checkOverflow);
      return () => window.removeEventListener("resize", checkOverflow);
    }
  }, [children]);

  return (
    <div className={className}>
      <div ref={containerRef} className={expanded ? "" : lineClampClass}>
        {children}
      </div>
      {showToggle && (
        <Button
          onClick={() => setExpanded((prev) => !prev)}
          variant="link"
          className="w-auto pl-0 pt-0"
        >
          {expanded ? "Show less" : "Show more"}
        </Button>
      )}
    </div>
  );
});
